import React from 'react';
import PredictiveSearch from '../../predictive-search/js/PredictiveSearch';
import ListingSelect from '../../listing/js/ListingSelect';
import PropTypes from 'prop-types';

export const VIEW_TYPE_GRID = "1";
export const VIEW_TYPE_LIST = "2";

export default class LotSearchControls extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onViewTypeChange = this.onViewTypeChange.bind(this);
    }

    onViewTypeChange(e) {
        this.props.onViewTypeChange(e.target.value);
    }

    render() {
        return (
            <div className="listing-controls__content-inner">

                {
                    this.props.options.showPredictive ? <div className="lots-search__text-search">
                        <PredictiveSearch inputClass="input input--white"
                                          isListing={true}
                                          query={this.props.filters.content}
                                          queryType={this.props.filters.type}
                                          onChange={this.props.onPredictiveSearchChange}/>
                    </div> : null
                }

                <div className="listing-controls__right">

                    {this.props.options.filters.map(filterConfig => (
                        <ListingSelect
                            key={filterConfig.name}
                            config={filterConfig}
                            value={this.props.filters[filterConfig.name]}
                            onChange={this.props.onFiltersChange}>
                        </ListingSelect>
                    ))}

                    <div className="listing__view-type">
                        <div className="radio-buttons">
                            <label className="radio-buttons__item">
                                <input className="radio-buttons__input"
                                       type="radio" value={VIEW_TYPE_GRID}
                                       checked={this.props.viewType === VIEW_TYPE_GRID}
                                       onChange={this.onViewTypeChange}/>
                                <div className="radio-buttons__placeholder">
                                    <svg className="radio-buttons__icon">
                                        <use xlinkHref="#icon-grid"></use>
                                    </svg>
                                </div>
                            </label>
                            <label className="radio-buttons__item">
                                <input className="radio-buttons__input"
                                       type="radio" value={VIEW_TYPE_LIST}
                                       checked={this.props.viewType === VIEW_TYPE_LIST}
                                       onChange={this.onViewTypeChange}/>
                                <div className="radio-buttons__placeholder">
                                    <svg className="radio-buttons__icon">
                                        <use xlinkHref="#icon-list"></use>
                                    </svg>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}


LotSearchControls.defaultProps = {
    options: {
        showPredictive: true,
        //filters config
        filters: [],
    }
};

LotSearchControls.propTypes = {
    onFiltersChange: PropTypes.func.isRequired,
    onViewTypeChange: PropTypes.func.isRequired,
    viewType: PropTypes.string.isRequired,
    onPredictiveSearchChange: PropTypes.func.isRequired,
    //actual filter values
    filters: PropTypes.object.isRequired,
    options: PropTypes.object,
};



// WEBPACK FOOTER //
// ./app/components/lots-search/js/LotSearchControls.js